/* tslint:disable */
/* eslint-disable */
/**
 * Organization & Workspace Gateway
 * Methods to manage all organizations and workspaces
 *
 * The version of the OpenAPI document: 22
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    ApiError,
    ApiErrorFromJSON,
    ApiErrorFromJSONTyped,
    ApiErrorToJSON,
} from './ApiError';

/**
 * 
 * @export
 * @interface WorkspaceAdminsResendResponseItem
 */
export interface WorkspaceAdminsResendResponseItem {
    /**
     * An HTTP status code indicating the status of the request for an invited workspace admin.
     * @type {number}
     * @memberof WorkspaceAdminsResendResponseItem
     */
    statusCode: number;
    /**
     * A portal admin unique identifier.
     * @type {string}
     * @memberof WorkspaceAdminsResendResponseItem
     */
    portalAdminId: string;
    /**
     * The email address of the workspace admin.
     * @type {string}
     * @memberof WorkspaceAdminsResendResponseItem
     */
    email?: string;
    /**
     * 
     * @type {ApiError}
     * @memberof WorkspaceAdminsResendResponseItem
     */
    error?: ApiError;
}

export function WorkspaceAdminsResendResponseItemFromJSON(json: any): WorkspaceAdminsResendResponseItem {
    return WorkspaceAdminsResendResponseItemFromJSONTyped(json, false);
}

export function WorkspaceAdminsResendResponseItemFromJSONTyped(json: any, ignoreDiscriminator: boolean): WorkspaceAdminsResendResponseItem {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'statusCode': json['statusCode'],
        'portalAdminId': json['portalAdminId'],
        'email': !exists(json, 'email') ? undefined : json['email'],
        'error': !exists(json, 'error') ? undefined : ApiErrorFromJSON(json['error']),
    };
}

export function WorkspaceAdminsResendResponseItemToJSON(value?: WorkspaceAdminsResendResponseItem | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'statusCode': value.statusCode,
        'portalAdminId': value.portalAdminId,
        'email': value.email,
        'error': ApiErrorToJSON(value.error),
    };
}

